
import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { getFormatDate } from "@/common/utils";
import { getToolsPageList } from "@/api/policyTools";
import { getStorage } from "@/common/utils";
// import Pagination from '@components/pagination/CenterPagination.vue';
@Component({
  name: "Match",
  components: {},
})
export default class Match extends Vue {
  @Getter("role") private role: any;
  @Getter("id") private id!: string;
  @Getter("cityId") private cityId!: string;
  @Getter("company") private company!: string;
  @Action("policy/getMatchList") private getTableList: any;
  @Action("policy/searchPolicyData") private getMatchList: any;
  @Getter("roleSave") private roleSave!: string;
  res: any = this.$route.params.res || null;
  $https: any;
  current = 1;
  totalPage = 1;
  totalData = 3;
  informData = [
    // {
    //   title: '支持文旅企业应对新冠肺炎疫情加快转型发展相关措施',
    //   company: '云南省文化和旅游厅',
    //   date: '2020-09-15至2020-12-30',
    // },
    // {
    //   title: '2020年市级文化产业发展专项资金',
    //   company: '昆明市委宣传部',
    //   date: '2020-08-12至2020-10-13',
    // },
    // {
    //   title: '2020年度服务贸易资金专项资金',
    //   company: '经济和科技促进局',
    //   date: '2020-07-20至2020-09-30',
    // },
  ];
  dialogVisible: Boolean = false;
  policyToolData: any = [];
  created() {
    this.match();
    this.getToolsPageListThree();
  }
  mounted() {
    console.log(this.$refs.test, 9999);
  }
  calculate() {
    this.dialogVisible = true;
    // this.$confirm("333", "提示", {
    //   confirmButtonText: "国家高新技术企业评测",
    //   cancelButtonText: "中小微企业评测",
    //   type: "warning",
    // })
    //   .then(() => {
    //     this.toCalculate(0);
    //   })
    //   .catch(() => {
    //     this.toCalculate(1);
    //   });
  }
  //获取政策工具列表数据
  getToolsPageListThree() {
    this.policyToolData = [];
    getToolsPageList({ pageSize: 9999, pageNumber: 1 }).then((res: any) => {
      if (res.data.success) {
        let arr = res.data.result.records;
        arr.map((item: any, index: number) => {
          this.policyToolData.push({
            name: item.name,
            id: item.id,
            path: "/pcm/verify",
          });
        });
      }
    });
    console.log(this.policyToolData, "policyToolData");
  }
  toCalculate(type: any) {
    // 0-高新|1中小
    this.$router.push({
      path: `/${this.role}/calculate`,
      query: {
        type,
      },
    });
  }
  tableRowClassName({ row, rowIndex }: any) {
    if (rowIndex % 2 === 1) {
      return "success-row";
    } else if (rowIndex % 2 === 0) {
      return "warning-row";
    }
    return "";
  }
  currentChange(param: number) {
    this.current = param;
    // this.getInformData();
  }
  goSB() {
    if (this.roleSave === 1) {
      const data = getStorage("basic");
      if (data) {
        const { nickName } = data;
        this.$router.push({
          path: "/pcm/company",
          query: {
            params: nickName,
          },
        });
      }
    } else {
      this.$message("请先认证！");
    }
  }
  goZc(item: any) {
    this.$router.push({
      path: item.path,
      query: {
        policyId: item.id,
        name: item.name,
      },
    });
  }
  match() {
    // const unitList = ["unit", "declare"];
    // if (!unitList.includes(this.role) || !this.company) {
    //   return;
    // }
    // company
    let options: any = {
      order: "desc",
      sort: "releaseDate",
      locationAddressCode: this.cityId,
    };
    this.getMatchList(options).then((res: any) => {
      let list = res.result.records;
      this.informData = list.map((item: any) => {
        item.lead = item.title;
        item.issuingOrgan = item.departmentName;
        item.releaseTime = item.gmtEnd;
        return item;
      });
      console.log(this.informData, "9999");
    });
  }
  getData() {
    const options = {
      current: this.current,
      size: 10,
      // unitName: this.company,
      // userId: this.id,
    };

    this.getTableList(options).then((res: any) => {
      const { code, data, msg } = res;
      if (code === 0 && data) {
        const { list } = data;
        this.informData = list.map((item: any) => {
          item.releaseTime = getFormatDate(item.releaseTime);
          return item;
        });
        return data;
      }
      return data;
    });
  }
}
